import { render, staticRenderFns } from "./GuppyChatSidebar.vue?vue&type=template&id=7a22e6db&scoped=true&"
import script from "./GuppyChatSidebar.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebar.vue?vue&type=style&index=0&id=7a22e6db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22e6db",
  null
  
)

export default component.exports